export default __webpack_public_path__ + "static/bariol_serif_regular-webfont-32ba910a94a26dabe2cd9bcb1563fcca.ttf";